import * as React from "react";

function Download(props) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 8.5H9V5H10V9C10 9.13261 9.94732 9.25979 9.85355 9.35355C9.75979 9.44732 9.63261 9.5 9.5 9.5H0.5C0.367392 9.5 0.240215 9.44732 0.146447 9.35355C0.0526784 9.25979 0 9.13261 0 9V5H1V8.5ZM6 3.5H8.5L5 7L1.5 3.5H4V0.5H6V3.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDownload = React.memo(Download);
export default MemoDownload;
